import { DictionaryItem } from './dictionary.model';
import { ContactData } from './document.model';
import { Party } from './party.domain';
import { GenericProductConfiguration, VehicleDefinition } from './product.domain';

export class FrontierRequest {
    party: Party = new Party();
    location: string = null;
    contactData: ContactData = new ContactData();
    vehicleDefinition: VehicleDefinition = new VehicleDefinition();
    vehicleOriginCountry: DictionaryItem = new DictionaryItem();
    insurancePeriod: DictionaryItem = new DictionaryItem('DAYS_30');
    insuranceStartDate: string = null;
    paymentType: DictionaryItem = new DictionaryItem('WIRE_TRANSFER');
}


export class FrontierSummary {
    clauseMap: { [param: string]: boolean };
}

export class FrontierConfiguration extends GenericProductConfiguration {
    frontierLiability: FrontierLiability;
    insurancePeriod: DictionaryItem;
    vehicleDefinition: VehicleDefinition = new VehicleDefinition();
    vehicleOriginCountry: DictionaryItem = new DictionaryItem();
}

export class FrontierLiability {
    number: string;
    selected: boolean;
}

export class PremiumRequest {
    premium: number;
}
